import React from 'react';
import { motion } from 'framer-motion';

interface HomeScreenProps {
  onSelectMode: (mode: 'letters' | 'numbers') => void;
}

const HomeScreen: React.FC<HomeScreenProps> = ({ onSelectMode }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-sky-200 via-purple-100 to-pink-200 flex flex-col items-center justify-center p-6"
    >
      <motion.h1
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, type: 'spring', stiffness: 120 }}
        className="text-6xl md:text-8xl font-bold text-purple-700 mb-4"
      >
        ຮຽນລາວ
      </motion.h1>

      <motion.p
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-xl md:text-2xl text-purple-500 mb-12"
      >
        📚 ມາຮຽນພາສາລາວກັນ!
      </motion.p>

      <div className="flex flex-col sm:flex-row gap-6">
        <motion.button
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.6, type: 'spring' }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onSelectMode('letters')}
          className="min-w-[200px] min-h-[120px] bg-gradient-to-br from-orange-400 to-red-400 text-white rounded-3xl shadow-xl px-8 py-6 text-3xl font-bold active:shadow-inner"
        >
          <span className="text-5xl block mb-2">ກ ຂ</span>
          ພະຍັນຊະນະ
        </motion.button>

        <motion.button
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.8, type: 'spring' }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onSelectMode('numbers')}
          className="min-w-[200px] min-h-[120px] bg-gradient-to-br from-green-400 to-teal-400 text-white rounded-3xl shadow-xl px-8 py-6 text-3xl font-bold active:shadow-inner"
        >
          <span className="text-5xl block mb-2">໑ ໒ ໓</span>
          ຕົວເລກ
        </motion.button>
      </div>
    </motion.div>
  );
};

export default HomeScreen;
